var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:_vm.tagClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.labels[_vm.status].label))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }